/**
 * Multiple-select problem input.
 */
import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

import CorrectAnswerCard from "./CorrectAnswerCard";
import WrongAnswerCard from "./WrongAnswerCard";
import RenderResponsePrompt from "./RenderResponsePrompt";
import SafeHtml from "pages/common/SafeHtml";

/**
 * Checkbox group that grades a sorted set of selected choices.
 *
 * @param {{ tag: Element, onSetAnswer?: Function }} props
 */
export default function ChoiceResponseRender(props) {
  const { tag, grade, onSetAnswer, isShowMark, setShowMark, blockId, pkey } = props;

  const [options, setOptions] = useState([]);
  const [selection, setSelection] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [isCorrect, setIsCorrect] = useState(false);

  useEffect(() => {
    if (!tag) return;

    let choices = tag.querySelector("checkboxgroup");
    if (!choices) return;
    choices = choices.children;

    const chos = [];
    const corr = [];

    for (let i = 0; i < choices.length; i++) {
      chos.push({ value: "choice_" + i, text: choices[i].innerHTML });
      if (choices[i].getAttribute("correct") === "true") corr.push("choice_" + i);
    }

    setOptions(chos);
    setCorrectAnswer(corr);
  }, [tag]);

  /**
   * Toggles a choice, grades the selection, and reports the answer.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} e Change event.
   * @returns {void}
   */
  const onChange = (e) => {
    setShowMark(false);

    const val = e.target.value;
    let selectionTmp = [...selection];
    const index = selectionTmp.indexOf(val);
    index > -1 ? selectionTmp.splice(index, 1) : selectionTmp.push(val);

    selectionTmp = selectionTmp.sort();
    setSelection(selectionTmp);

    const correct = selectionTmp.join(",") === [...correctAnswer].sort().join(",");

    onSetAnswer({
      id: grade?.id,
      student_answer: JSON.stringify(selectionTmp),
      correctness: correct ? "correct" : "incorrect",
    });

    setIsCorrect(correct);
  };

  return (
    <div className="mb-2">
      <RenderResponsePrompt tag={tag} />

      {options.map((opt) => (
        <div key={opt.value} style={{ display: "block" }}>
          <FormControlLabel
            sx={{ display: "flex", width: "100%", m: 0 }}
            control={
              <Checkbox
                id={`${blockId}-${pkey}-${opt.value}`}
                checked={selection.includes(opt.value)}
                value={opt.value}
                onChange={onChange}
              />
            }
            label={<SafeHtml as="span" html={opt.text} course />}
          />
        </div>
      ))}

      {isShowMark && (isCorrect ? <CorrectAnswerCard /> : <WrongAnswerCard />)}
    </div>
  );
}
